(ns manatee.fx.local-storage
  (:require #?@(:cljs [[cognitect.transit :as t]
                       [taoensso.timbre :as log]])
            [clojure.string :as str]
            [re-frame.core :as rf]))

(def w #?(:cljs (t/writer :json)))
(def r #?(:cljs (t/reader :json)))

(def storage
  #?(:cljs js/localStorage
     :clj  (atom nil)))

(def global-prefix "manatee.")

(defn- safe-key [key]
  (str global-prefix (name key)))

(defn get-keys
  [local-prefix]
  (into
   []
   (comp (remove nil?)
         (filter #(str/starts-with? % (str global-prefix local-prefix)))
         (map #(str/replace-first % global-prefix "")))
   #?(:cljs (map #(.key storage %) (range 0 (.-length storage)))
      :clj  (keys @storage))))

#?(:cljs
   (defn deserialise-value*
     [s]
     (if (and (string? s)
              (= (subs s 0 1) "\"")
              (str/ends-with? s "\""))
       ;; Backward compatibility. We were using `goog.storage.mechanism.HTML5LocalStorage`
       ;; wrapper which was adding extra encoding, so we have to undo it.
       (t/read r (js/JSON.parse s))

       (t/read r s))))

#?(:cljs
   (defn deserialise-value
     [s]
     (try
       (deserialise-value* s)
       (catch :default e
         (log/error "Error deserialising a local storage value" {:value s :error e})))))

(defn get-value
  [key]
  #?(:cljs (when-let [s (.getItem storage (safe-key key))]
             (deserialise-value s))
     :clj  (get @storage (safe-key key))))

(defn set-value
  [key value]
  #?(:cljs (.setItem storage (safe-key key) (t/write w value))
     :clj  (swap! storage assoc (safe-key key) value)))

(defn remove-value
  [key]
  #?(:cljs (.removeItem storage (safe-key key))
     :clj  (swap! storage dissoc (safe-key key))))

(rf/reg-cofx
 ::get-value
 (fn [coeffects key]
   (assoc coeffects ::get-value (get-value key))))

(rf/reg-cofx
 ::get-keys-by-prefixes
 (fn [coeffects local-prefixes]
   (assoc coeffects ::get-keys-by-prefixes (->> local-prefixes
                                                (map (fn [s] [s (get-keys s)]))
                                                (into {})))))

(rf/reg-fx
 ::fetch-values-by-key-fragment
 (fn [[key-fragment event]]
   (let [fetched (->> (get-keys "")
                      (filter #(str/includes? % key-fragment))
                      (map (fn [k] [k (get-value k)]))
                      (into {}))]
     (rf/dispatch (conj event fetched)))))

(rf/reg-fx
 ::set-value
 (fn [{:keys [key value on-success on-failure]}]
   (try
     (set-value key value)
     (when on-success
       (rf/dispatch on-success))
     (catch #?(:clj Exception :cljs :default) e
       (when on-failure
         (rf/dispatch (conj on-failure e)))))))

(rf/reg-fx
 ::remove-values-by-keys
 (fn [keys]
   (doseq [key keys]
     (remove-value key))))

(rf/reg-fx
 ::remove-values-by-key-fragments
 (fn [key-fragments]
   (let [keys (->> (get-keys "")
                   (filter (fn [k] (some (fn [kf] (str/includes? k kf)) key-fragments))))]
     (doseq [key keys]
       (remove-value key)))))
